import(/* webpackMode: "eager" */ "/tmp/8de6eb5fa180ad0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de6eb5fa180ad0/src/components/SofiaBot.jsx");
